import BootstrapSlider from "@core/Components/Util/BootstrapSlider.vue";

import {createNamespacedHelpers} from 'vuex';

const { mapGetters, mapMutations} = createNamespacedHelpers('audienceManager/builder');

const minPlaceholderValue = 15;
const maxPlaceholderValue = 150;

export default {
    name: "RangeSliderQuestion",
    components: {
        BootstrapSlider
    },
    methods: mapMutations(['setQuestionValue']),
    computed: {
        //TODO: Implement min/max
        min(){
            return minPlaceholderValue;
        },
        max(){
            return maxPlaceholderValue;
        },
        isFreeInput(){
            //TODO: Determine based on question
            return true;
        },
        valueMin: {
            get() {
                return this.value[0];
            },
            set(min) {
                this.value = [min, this.value[1]];
            }
        },
        valueMax: {
            get() {
                return this.value[1];
            },
            set(max) {
                this.value = [this.value[0], max];
            }
        },
        value: {
            get(){
                //Ensure we never have an undefined value
                //create a new array to prevent potential modification of our source array
                return [...this.questionValue(this.questionId) || [this.min, this.max]];
            },
            set(value){
                // //Ensure max is never below min/min is never above max
                value[0] = Math.min(value[0], value[1] - 1);
                value[1] = Math.max(value[1], value[0] + 1);

                // //Prevent our value from exceeding the configured min/max
                value[0] = Math.max(value[0], this.min);
                value[1] = Math.min(value[1], this.max);

                this.setQuestionValue({
                    questionId: this.questionId,
                    value: value
                });
            }
        },
        ...mapGetters(['questionValue']),
        ...mapGetters({
            'canEdit': 'canEditAudienceQuestionAnswers'
        })
    },
    data: () => ({
        sliderConfiguration: {
            range: true
        }
    }),
    props: {
        questionId: {
            type: String,
            required: true
        }
    }
}